import { QUICK_INFO_BUTTONS } from '@aibees/elephant/components/quick-info-group/components/quick-info-button';
import {
  ProcessingItemState,
  useActionButtonContext,
} from '@aibees/elephant/context/action-button-context';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { isJobChangeHappened } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/utils';
import { ENRICHMENT_STATE } from '@aibees/elephant/types';
import { useEffect } from 'react';

export function useCheckEmailEnrichmentProcessing(item?: PeopleTableInfo) {
  const { removeProcessingItems, getItemState } = useActionButtonContext();

  useEffect(() => {
    const id = item?.id ?? '';
    const state = item?.revelation?.email?.state;
    if (
      !!state &&
      (state === ENRICHMENT_STATE.SUCCESS || state === ENRICHMENT_STATE.FAILED)
    ) {
      removeProcessingItems({
        id,
        type: QUICK_INFO_BUTTONS.EMAIL_ENRICHMENT,
      });
      return;
    }

    // A company-change run deletes the current email, and on a contact that
    // never had one it leaves revelation.email null altogether — so the gate
    // above can never fire and the spinner would run forever. The backend clears
    // changes.COMPANY when that run completes, which is the durable end signal
    // for this flow. Mirrors the changes.CONTACT fallback that
    // useCheckContactDetailsProcessing uses for the same reason.
    const processingState = getItemState({
      id,
      type: QUICK_INFO_BUTTONS.EMAIL_ENRICHMENT,
    });
    if (
      processingState === ProcessingItemState.CHECKING_FOR_UPDATE &&
      !isJobChangeHappened(item)
    ) {
      removeProcessingItems({
        id,
        type: QUICK_INFO_BUTTONS.EMAIL_ENRICHMENT,
      });
    }
    // `getItemState` is deliberately not a dependency. It is rebuilt whenever
    // `processingItems` changes, and `removeProcessingItems` always stores a
    // fresh array — so listing it would make the SUCCESS/FAILED branch above
    // re-run its own removal forever. The effect only fires on `item`, and the
    // closure is rebuilt on that render, so it never reads a stale accessor.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, removeProcessingItems]);

  return null;
}
